import Controller, { OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames, TipoChamadoAliases } from '../../codegen';
import { Routes } from '../../definitions/routes';
import BaseController from '../base/base-controller';

import './call-controller.css';

interface CallCategory {
  nrSeqCategory: number,
  dsCategory: string,
}

@Controller({ fragment: FragmentNames.TIPO_CHAMADO })
class TipoChamadoController extends BaseController {

  @OnSelectItem(TipoChamadoAliases.DECK_CATEGORIES)
  onSelectitemDeckCategories(event: SelectItemEvent<CallCategory>): void {
    const { nrSeqCategory } = event.item;
    this.historyService.push(Routes.NOVO_CHAMADO, { nrSeqCategory });
  }

}

export default TipoChamadoController;
